import {
  updateResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';
import {
  REPORT,
  REPORT_ACCOUNT_RECEIVABLE,
  REPORT_ACCOUNT_RECEIVABLE_FINISHED
} from './reportActions';

const handleError = (state, action) => {
  return updateResourceState(state, action, RESOURCE, () => ({
    loading: false
  }));
};

const reportReducer = createResourceReducer(
  REPORT,
  [],
  {
    [REPORT_ACCOUNT_RECEIVABLE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [REPORT_ACCOUNT_RECEIVABLE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        accountsReceivables: action.payload.data.result,
        loading: false
      }));
    }
  },
  handleError
);

export default reportReducer;
